import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Default visibility - all pages visible
const defaultVisibility = {
  home: true,
  about: true,
  sermons: true,
  podcast: true,
  events: true,
  programs: true,
  pantries: true,
  partners: true,
  blog: true,
  prayers: true,
  qa: true,
  donate: true,
  volunteer: true,
  contact: true,
  imNew: true,
  watch: true,
  smallGroups: true,
  kids: false  // Youth ministry not currently active
};

export function usePageVisibility() {
  const [visibility, setVisibility] = useState(defaultVisibility);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVisibility = async () => {
      try {
        const response = await axios.get(`${API}/page-visibility`);
        if (response.data) {
          setVisibility({ ...defaultVisibility, ...response.data });
        }
      } catch (error) {
        console.log('Using default page visibility');
      } finally {
        setLoading(false);
      }
    };

    fetchVisibility();
  }, []);

  return { visibility, loading };
}

export default usePageVisibility;
